<template>
  <Layout>
    <Aguarde :show="httpSend"></Aguarde>
    <PageHeader :title="title" :items="items"/>
    <div v-if="empresa_visualizar && empresa_visualizar.eco_codigo" class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div v-if="empresa_visualizar.pes_cpfcnpj" class="row">
              <div class="col-md-6">
                <div class="media">
                  <div class="media-body align-self-center">
                    <div class="text-muted">
                      <h5 class="mb-1">{{ empresa_visualizar.pes_nome }}</h5>
                      <p class="mb-0" v-if="empresa_visualizar.pes_cpfcnpj.length < 12">
                        {{ empresa_visualizar.pes_cpfcnpj | VMask('###.###.###-##') }}</p>
                      <p class="mb-0" v-else>{{ empresa_visualizar.pes_cpfcnpj | VMask('##.###.###/####-##') }}</p>
                      <p class="mb-0">{{ empresa_visualizar.eco_nome_fantasia }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="divergencias && divergencias.length > 0" class="row">
      <div class="col-sm-12">
        <div class="card border-0 shadow-sm mb-4 divergencias-card">
          <div class="card-body p-3">
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-3 border-bottom pb-2">
              <div class="d-flex align-items-center">
                <div class="avatar-xs mr-2">
                  <span class="avatar-title rounded-circle bg-soft-danger text-danger font-size-16">
                    <i class="bx bxs-error-circle"></i>
                  </span>
                </div>
                <div>
                  <h5 class="font-size-15 mb-0 text-danger font-weight-bold">Períodos com Divergência</h5>
                  <p class="text-muted font-size-12 mb-0">Clique em uma competência para carregar os dados para
                    análise</p>
                </div>
              </div>
              <div class="d-flex align-items-center mt-2 mt-sm-0">
                <span class="badge badge-soft-danger badge-pill px-3 py-1 font-size-12">
                  <i class="bx bx-error mr-1"></i> {{
                    divergencias.length
                  }} {{ divergencias.length === 1 ? 'competência divergente' : 'competências divergentes' }}
                </span>
              </div>
            </div>

            <!-- Filtro por ano quando houver mais de 1 ano -->
            <div v-if="anosDivergencias.length > 1" class="mb-3 d-flex flex-wrap align-items-center">
              <span class="text-muted font-size-12 mr-2 font-weight-semibold">
                <i class="bx bx-filter-alt mr-1"></i>Filtrar por ano:
              </span>
              <div class="btn-group btn-group-sm flex-wrap" role="group">
                <button
                    type="button"
                    class="btn btn-sm"
                    :class="filtroAnoDivergencia === 'todos' ? 'btn-danger font-weight-semibold' : 'btn-light text-muted'"
                    @click="filtroAnoDivergencia = 'todos'">
                  Todos ({{ divergencias.length }})
                </button>
                <button
                    v-for="item in anosDivergencias"
                    :key="item.ano"
                    type="button"
                    class="btn btn-sm"
                    :class="filtroAnoDivergencia === item.ano ? 'btn-danger font-weight-semibold' : 'btn-light text-muted'"
                    @click="filtroAnoDivergencia = item.ano">
                  {{ item.ano }} <span class="badge badge-pill ml-1"
                                       :class="filtroAnoDivergencia === item.ano ? 'badge-light text-danger' : 'badge-secondary'">{{
                    item.total
                  }}</span>
                </button>
              </div>
            </div>

            <!-- Lista de divergências agrupadas por ano -->
            <div class="divergencias-container">
              <div v-for="grupo in divergenciasExibidas" :key="grupo.ano" class="divergencia-ano-bloco">
                <div class="d-flex align-items-center mb-2">
                  <span class="badge badge-light font-size-12 px-2 py-1 mr-2">
                    <i class="bx bx-calendar mr-1"></i> {{ grupo.ano }}
                  </span>
                  <small class="text-muted font-weight-medium">
                    {{ grupo.itens.length }} {{ grupo.itens.length === 1 ? 'período' : 'períodos' }}
                  </small>
                </div>
                <div class="d-flex flex-wrap gap-2 periodos-grid">
                  <button
                      v-for="d in grupo.itens"
                      :key="d.competencia"
                      type="button"
                      @click="sel_periodo(d.competencia)"
                      title="Carregar competência para análise"
                      class="btn btn-sm periodo-btn transition-all"
                      :class="competencia === d.competencia ? 'btn-danger shadow-sm active-periodo' : 'btn-outline-danger'"
                  >
                    <i :class="competencia === d.competencia ? 'bx bx-check-circle mr-1' : 'bx bx-error-circle mr-1'"></i>
                    <span class="mes-nome">{{ d.mes | monthNames }}</span>
                    <span class="ano-sub" v-if="filtroAnoDivergencia === 'todos'">/{{ d.ano }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix">
              <div class="row">
                <div class="col-sm-12">
                  <div class="float-left">
                    <div class="input-group input-group-sm">
                      <div class="input-group-prepend">
                        <span class="input-group-text font-weight-semibold">
                          <i class="bx bx-calendar mr-1"></i> Competência
                        </span>
                      </div>
                      <select @change="alter_ano()" v-model="filtro.ano" class="custom-select custom-select-sm">
                        <option v-for="(mesesAno, ano) in periodos" :key="ano" v-bind:value="ano">{{ ano }}</option>
                      </select>
                      <select v-model="filtro.mes" @change="apuracao_simples_time()"
                              class="custom-select custom-select-sm">
                        <option v-for="m in meses" :key="m" v-bind:value="m">{{ m | monthNames }}</option>
                      </select>
                      <!--
                      <div class="input-group-append">
                        <button type="button" @click="apuracao_simples_time()" class="btn btn-primary">
                          <i class="bx bx-check-double"></i> Verificar
                        </button>
                      </div>
                      -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mt-3">
                <b-tabs v-model="tabIndex" justified nav-class="nav-tabs-custom" content-class="text-muted">
                  <b-tab active>
                    <template v-slot:title>
                      <span>Apuração</span>
                    </template>
                    <SimplesApuracao :eco_codigo="eco_codigo_atual" :competencia="competencia"
                                     ref="apuracao"></SimplesApuracao>
                  </b-tab>
                  <b-tab>
                    <template v-slot:title><span>DAS-D</span></template>
                    <SimplesDas :eco_codigo="eco_codigo_atual" :competencia="competencia"
                                :pes_cpfcnpj="pes_cpfcnpj_atual" ref="das"></SimplesDas>
                  </b-tab>
                  <b-tab>
                    <template v-slot:title><span>NFS-e</span></template>
                    <SimplesNfse :eco_codigo="eco_codigo_atual" :competencia="competencia" ref="nfse"></SimplesNfse>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/dados/app.config.json";
import Layout from "../../../layouts/main";
import Aguarde from "@/components/widgets/aguarde";
import PageHeader from "@/components/page-header";
import SimplesApuracao from "@/router/views/contribuinte/simples/components/simples-apuracao";
import SimplesDas from "@/router/views/contribuinte/simples/components/simples-das";
import SimplesNfse from "@/router/views/contribuinte/simples/components/simples-nfse";
import {listPeriodoDivergencia} from "@/api/simples_nacional/apuracao";
import {notifyAviso} from "@/helps/notificacao";

export default {
  page: {
    title: "Fiscalização do Simples Nacional",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Aguarde,
    PageHeader,
    SimplesApuracao,
    SimplesDas,
    SimplesNfse
  },
  data() {
    return {
      title: "Fiscalização do Simples Nacional",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Simples Nacional',
          href: '/contribuinte/simples/fiscalizacao',
        },
        {
          text: 'Fiscalização',
          active: true,
        },
      ],
      httpSend: false,
      ano_incial: null,
      mes_inicial: null,
      eco_codigo_atual: null,
      pes_cpfcnpj_atual: null,
      empresa_visualizar: null,
      anos: [],
      meses: [],
      filtro: {
        ano: new Date().getFullYear().toString(),
        mes: String((new Date().getMonth() + 1)).padStart(2, '0')
      },
      tabIndex: 0,
      divergencias: [],
      periodos: [],
      filtroAnoDivergencia: 'todos'
    };
  },
  created() {
    this.inicializar()
  },
  computed: {
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
    competencia: {
      get: function () {
        const mes = String(this.filtro.mes).padStart(2, "0");
        return String(this.filtro.ano) + mes;
      }
    },
    divergenciasAgrupadas() {
      if (!this.divergencias || this.divergencias.length === 0) {
        return [];
      }
      const grupos = {};
      this.divergencias.forEach(d => {
        const comp = String(d.esr_competencia);
        const ano = comp.slice(0, 4);
        const mes = comp.slice(4, 6);
        if (!grupos[ano]) {
          grupos[ano] = {
            ano,
            itens: []
          };
        }
        grupos[ano].itens.push({
          ...d,
          ano,
          mes,
          competencia: comp
        });
      });

      return Object.keys(grupos)
          .sort((a, b) => Number(b) - Number(a))
          .map(ano => {
            grupos[ano].itens.sort((a, b) => Number(b.mes) - Number(a.mes));
            return grupos[ano];
          });
    },
    anosDivergencias() {
      return this.divergenciasAgrupadas.map(g => ({
        ano: g.ano,
        total: g.itens.length
      }));
    },
    divergenciasExibidas() {
      if (this.filtroAnoDivergencia === 'todos') {
        return this.divergenciasAgrupadas;
      }
      return this.divergenciasAgrupadas.filter(g => g.ano === this.filtroAnoDivergencia);
    }
  },
  watch: {
    '$route.fullPath'() {
      this.inicializar()
    },
    tabIndex(newTab) {
      if (newTab === 1) {
        this.$refs.das.list_declaracao();
      }
      if (newTab === 2) {
        this.$refs.nfse.list_notas_simples();
      }
    }
  },
  methods: {
    inicializar() {
      const aux_eco_codigo = this.$route.params.eco_codigo
      if (aux_eco_codigo) {
        this.eco_codigo_atual = aux_eco_codigo;
        this.pes_cpfcnpj_atual = this.$route.params.eco_cnpj
        this.periodo_divergente()
      } else {
        if (!this.empresa || !this.empresa.eco_tributacao) {
          notifyAviso("Nenhuma empresa selecionada", "Selecione uma empresa")
          this.$router.push({name: 'painel'})
        } else {
          this.eco_codigo_atual = this.empresa.eco_codigo;
          this.pes_cpfcnpj_atual = this.empresa.pes_cpfcnpj;
          this.periodo_divergente()
        }
      }
    },
    alter_ano() {
      this.meses = this.periodos[this.filtro.ano] || [];
      if (this.meses.length > 0) {
        const mesAtual = Number(this.filtro.mes);
        const hasMes = this.meses.some(m => Number(m) === mesAtual);
        if (!hasMes) {
          this.filtro.mes = Math.max(...this.meses.map(Number));
        }
        setTimeout(() => this.apuracao_simples(), 500);
      }
    },
    sel_periodo(competencia) {
      const ano = String(competencia).slice(0, 4);
      const mes = String(competencia).slice(4, 6);
      this.filtro.ano = ano;
      this.alter_ano();
      const mesNum = parseInt(mes, 10);
      const foundMes = this.meses ? this.meses.find(m => Number(m) === mesNum) : null;
      this.filtro.mes = foundMes !== undefined && foundMes !== null ? foundMes : mesNum;
      setTimeout(() => this.apuracao_simples(), 500);
    },
    periodo_divergente() {
      this.httpSend = true;
      listPeriodoDivergencia(this.eco_codigo_atual).then(result => {
        const d = result.dados;
        this.empresa_visualizar = d.empresa;
        this.ano_incial = d.ano_inicial;
        this.mes_inicial = d.mes_inicial;
        this.anos = d.anos;
        this.divergencias = d.apuracoes;
        this.periodos = d.periodos;
        if (this.periodos && Object.keys(this.periodos).length > 0) {
          this.filtro.ano = String(Math.max(...Object.keys(this.periodos).map(Number)));
          this.alter_ano();
          this.filtro.mes = Math.max(...this.meses.map(Number));
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    apuracao_simples_time() {
      setTimeout(() => this.apuracao_simples(), 500);
    },
    apuracao_simples() {
      this.$refs.apuracao.list_apuracao();
      this.$refs.das.list_declaracao();
      this.$refs.nfse.list_notas_simples();
    }
  }
};
</script>

<style scoped>
.custom-select {
  min-width: 100px;
}

.divergencias-card {
  border-left: 4px solid #f46a6a !important;
  background: #ffffff;
  border-radius: 8px;
}

.divergencias-container {
  max-height: 280px;
  overflow-y: auto;
  padding-right: 4px;
}

.divergencias-container::-webkit-scrollbar {
  width: 5px;
}

.divergencias-container::-webkit-scrollbar-thumb {
  background-color: #f1b4b4;
  border-radius: 4px;
}

.divergencias-container::-webkit-scrollbar-track {
  background: #f8f9fa;
}

.periodos-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.periodo-btn {
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
  margin-right: 6px;
  margin-bottom: 6px;
}

.periodo-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 3px 6px rgba(244, 106, 106, 0.25);
}

.active-periodo {
  box-shadow: 0 0 0 2px rgba(244, 106, 106, 0.35), 0 3px 8px rgba(244, 106, 106, 0.4) !important;
  transform: translateY(-1px);
}

.mes-nome {
  margin-right: 2px;
}

.ano-sub {
  opacity: 0.85;
  font-size: 11px;
}

.bg-soft-danger {
  background-color: rgba(244, 106, 106, 0.15) !important;
}
</style>
